import { pxToRem, theme } from '@vfit/shared/themes';
import styled from 'styled-components';

export const ScrollableIndicator = styled.div`
  background-color: ${theme.colors.border.default};
  border-radius: ${theme.radius.md};
  height: ${pxToRem(6)};
  left: 50%;
  position: absolute;
  top: ${pxToRem(11)};
  transform: translateX(-50%);
  width: ${pxToRem(42)};
`;

